function debounce(func, timeout = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}


/**
 * example of ussage
 * 
 * <input onChange={useCallback(debounce(reloadArchived, 500), [reloadArchived])}></input>
 * 
 *  const reloadArchived = useCallback(() => {
    console.warn('called after 500ms');
  }, []);
 */

export default debounce;